export enum ErrorCodes {
  invalidChannel = 'invalid-channel-identifier',
  forbidden = 'Forbidden',
}

export interface RequestError {
  data: { message: string; code: string };
}
